import React, { useState } from "react";
import SignIn from "../components/SignIn";
import SignUp from "../components/SignUp";
import ForgotPassword from "../components/ForgotPassword";
import { Link } from "react-router-dom";

const featureCards = [
  {
    title: "Real-time Tracking",
    desc: "Monitor your finances instantly as they happen",
    color: "from-blue-500 to-blue-600",
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
      />
    ),
  },
  {
    title: "Team Collaboration",
    desc: "Work together seamlessly with your entire team",
    color: "from-purple-500 to-purple-600",
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
      />
    ),
  },
  {
    title: "Smart Reports",
    desc: "Generate automated monthly summaries with one click",
    color: "from-red-500 to-red-600",
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    ),
  },
  {
    title: "Budget Management",
    desc: "Set custom limits and stay in control",
    color: "from-emerald-500 to-teal-600",
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8V6m0 10v2m6-6a6 6 0 11-12 0 6 6 0 0112 0z"
      />
    ),
  },
  {
    title: "Secure Data",
    desc: "Protect your data with enterprise grade encryption",
    color: "from-slate-600 to-slate-800",
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 11c1.657 0 3 .895 3 2v3a3 3 0 11-6 0v-3c0-1.105 1.343-2 3-2zm0-4a4 4 0 00-4 4v2h8v-2a4 4 0 00-4-4z"
      />
    ),
  },
];

const LaunchScreen = () => {
  const [view, setView] = useState("signin");
  const [verifyData, setVerifyData] = useState(null);

  const toggleForm = () => {
    setView((prev) => (prev === "signin" ? "signup" : "signin"));
  };

  const handleVerificationStart = ({ email, sessionId, name }) => {
    setVerifyData({ email, sessionId, name });
    setView("verify");
  };

  const handleVerified = () => {
    window.location.href = "/dashboard";
  };

  return (
    <div
      className="flex flex-col min-h-screen font-customFont relative overflow-hidden overflow-x-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url("./launchbg.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Optional: Keep some decorative elements for extra depth */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
      <div className="absolute top-40 right-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
      <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>

      {/* Header */}
      <div className="sticky top-0 left-0 right-0 z-20 ">
        <div className="flex items-center px-6 py-4 mx-auto">
          <img src="../logo.png" className="w-[50px]" />
          <h1 className="text-3xl font-bold text-gray-800">Expense</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row items-center justify-between flex-1 px-4 sm:px-6 md:px-10 py-12 z-10 gap-12 max-w-7xl mx-auto w-full">
        {/* Left Side - Hero Content */}
        <div className="w-full lg:w-1/2 space-y-6 animate-fade-in-up">
          <div className="inline-block">
            <span className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
              🚀 Track. Analyze. Optimize.
            </span>
          </div>

          <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
            <span className="text-gray-800">Predictable</span>
            {/* <br /> */}
            <span className="bg-themeGradient bg-clip-text text-transparent">
              {" "}
              growth
            </span>
            <br />
            <span className="bg-themeGradient bg-clip-text text-transparent">
              {" "}
              starts
            </span>
            <span className="text-gray-800"> here.</span>
          </h1>

          <p className="text-md lg:text-lg text-gray-600 leading-relaxed max-w-xl">
            Track every project's finances seamlessly! With team roles,
            multi-project management, and end-of-month email summaries, managing
            your finances has never been easier.
          </p>

          {/* Feature Slider */}
          <div className="py-4 overflow-hidden relative">
            {/* The container that moves */}
            <div className="flex w-max animate-slide hover:pause">
              {/* Render the cards twice for a perfect loop */}
              {[...featureCards, ...featureCards].map((card, i) => (
                <div
                  key={i}
                  className="w-[220px] sm:w-[260px] md:w-[300px] mx-3
                   bg-white/70 backdrop-blur-sm rounded-2xl p-5 
                   border border-white/30 hover:bg-white/60 
                   transition-all duration-300 
                   shadow-[0_10px_10px_rgba(0,0,0,0.08)] shrink-0"
                >
                  <div
                    className={`w-10 h-10 bg-gradient-to-br ${card.color} rounded-xl flex items-center justify-center mb-3`}
                  >
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      {card.icon}
                    </svg>
                  </div>

                  <h3 className="font-semibold text-gray-800 text-sm">
                    {card.title}
                  </h3>
                  <p className="text-xs text-gray-600 mt-1">{card.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Side - Auth Forms */}
        <div className="w-full lg:w-1/2 max-w-md px-2 sm:px-0 animate-fade-in-up animation-delay-300">
          <div className="transform transition-all duration-500 hover:scale-[1.02]">
            {view === "signin" && (
              <SignIn
                toggleForm={toggleForm}
                onForgot={() => setView("forgot")}
              />
            )}
            {view === "signup" && (
              <SignUp
                toggleForm={toggleForm}
                onVerificationStart={handleVerificationStart}
              />
            )}
            {view === "forgot" && (
              <ForgotPassword onBackToSignin={() => setView("signin")} />
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className=" z-10">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center text-sm text-center sm:text-left">
            <p className="text-gray-600 font-medium">
              © 2025 DGExpense. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link
                to="https://dgexpense.com/termsandconditions"
                className="text-gray-600 hover:text-blue-600 font-medium transition-colors"
              >
                Terms of Service
              </Link>
              <Link
                to="https://dgexpense.com/privacypolicy"
                className="text-gray-600 hover:text-blue-600 font-medium transition-colors"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes gradient {
          0%,
          100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }

        @keyframes blob {
          0%,
          100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slide {
          from {
            transform: translateX(0);
          }
          to {
            /* We move exactly half the width of the doubled container */
            transform: translateX(-50%);
          }
        }

        .animate-slide {
          animation: slide 25s linear infinite;
        }

        /* Smoothly pauses the animation on hover */
        .hover\:pause:hover {
          animation-play-state: paused;
        }

        /* Optional: Add a fade effect to the edges of the slider */
        .overflow-hidden::before,
        .overflow-hidden::after {
          content: "";
          position: absolute;
          top: 0;
          width: 50px;
          height: 100%;
          z-index: 2;
        }
        .overflow-hidden::before {
          left: 0;
          background: linear-gradient(
            to right,
            rgba(255, 255, 255, 1),
            transparent
          );
        }
        .overflow-hidden::after {
          right: 0;
          background: linear-gradient(
            to left,
            rgba(255, 255, 255, 1),
            transparent
          );
        }
      `}</style>
    </div>
  );
};

export default LaunchScreen;
